import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './demo-badge.module.scss';
import { DemoBadgeVariant, demoBadgeKey } from './demo-badge.types';

interface DemoBadgeProps {
  variant?: DemoBadgeVariant;
  className?: string;
}

export default function DemoBadge({ variant = 'demo', className }: DemoBadgeProps) {
  const { t } = useTranslation('metrics');

  return (
    <span className={clsx(styles.badge, styles[`badge-${variant}`], className)}>
      {t(demoBadgeKey[variant])}
    </span>
  );
}
